import {Component, inject, input, output, ChangeDetectionStrategy} from "@angular/core"
import {MatMenuModule} from "@angular/material/menu"
import {PermissionsService} from "@app/common/services/permissions/permissions.service"

export type TemplateTreeViewType = "tree" | "selectVariation" | "allVariations" | "performance"
export type SceneAggregationMode = "memoryUsage" | "downloadSize" | "triangles"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-template-tree-view-type-selector",
    imports: [MatMenuModule],
    templateUrl: "./template-tree-view-type-selector.component.html",
    styleUrl: "./template-tree-view-type-selector.component.scss",
})
export class TemplateTreeViewTypeSelectorComponent {
    readonly $viewType = input.required<TemplateTreeViewType>({alias: "viewType"})
    readonly $sceneAggregationMode = input.required<SceneAggregationMode>({alias: "sceneAggregationMode"})

    readonly viewTypeChanged = output<TemplateTreeViewType>()
    readonly sceneAggregationModeChanged = output<SceneAggregationMode>()

    private readonly permission = inject(PermissionsService)
    readonly $can = this.permission.$to
}
